export const getCoordinates = (coordinates) => ({
    type: 'GET_COORDINATES',
    coords: coordinates
});
